import { render, staticRenderFns } from "./DetailsFollower.vue?vue&type=template&id=301e2e01"
import script from "./DetailsFollower.vue?vue&type=script&lang=js"
export * from "./DetailsFollower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports